import { getApiConfirmation } from "./getApiConfirmation";
import { getApiConfirmationGetFile } from "./getApiConfirmationGetFile";
import { getApiConfirmationOpenEnrollment } from "./getApiConfirmationOpenEnrollment";
import { putApiConfirmation } from "./putApiConfirmation";

export function confirmationController() {
  return {
    getApiConfirmation,
    putApiConfirmation,
    getApiConfirmationOpenEnrollment,
    getApiConfirmationGetFile,
  };
}
